"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.annotateTextDecorationAst = void 0;
function annotateTextDecorationAst(ast) {
    ast.children.forEach(function (child) {
        switch (child.type) {
            case 'Function':
                child.classification = 'text-decoration-color';
                break;
            case 'Identifier':
                if (child.name) {
                    if (child.name.match(/(none)|(underline)|(overline)|(line-through)|(blink)/)) {
                        child.classification = 'text-decoration-line';
                    }
                    else if (child.name.match(/(solid)|(double)|(dotted)|(dashed)|(wavy)/)) {
                        child.classification = 'text-decoration-style';
                    }
                    else {
                        child.classification = 'text-decoration-color';
                    }
                }
                break;
            case 'Operator':
                return;
            case 'WhiteSpace':
                return;
            default:
                child.classification = 'text-decoration-color';
        }
    });
    return ast;
}
exports.annotateTextDecorationAst = annotateTextDecorationAst;
//# sourceMappingURL=text-decoration-grouper.js.map